<template>
  <div class="sync-content">
    <v-data-table
      :headers="data.headers"
      :items="data.items"
      :loading="data.loading"
      :options.sync="data.options"
      item-key="id"
      dense
      class="elevation-0"
      hide-default-footer
    >
      <template v-slot:item.syncedAt="{ item }">
        <DateTime :disable-time="false" :datetime="item.syncedAt" />
      </template>
      <template v-slot:footer><div class="v-data-footer"></div></template>
    </v-data-table>
    <v-row>
      <v-col class="ma-4 text-right">
        <v-btn type="submit" small depressed color="primary" @click.prevent="startDataSyncInfo()">
          Synchronizovat
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DateTime from '../DateTime'

export default {
  name: 'DataSyncInfo',
  components: { DateTime },
  data() {
    return {
      data: {
        items: [],
        loading: false,
        headers: [
          {
            text: '',
            value: 'type.text',
            sortable: false,
          },
          {
            text: '',
            value: 'syncedAt',
            sortable: false,
          },
        ],
        options: {
          sortBy: ['id'],
          sortDesc: [false],
        },
      },
    }
  },
  created() {
    this.loadDataSyncInfo()
  },
  methods: {
    ...mapActions({
      getDataSync: 'data/getDataSync',
      startDataSync: 'data/startDataSync',
    }),
    loadDataSyncInfo() {
      this.data.loading = true
      this.getDataSync(['TZB_SUPPLIER', 'TZB_ELECTRICITY_PRODUCT', 'TZB_GAS_PRODUCT'])
        .then((response) => {
          this.data.items = response.data
        })
        .finally(() => {
          this.data.loading = false
        })
    },
    startDataSyncInfo() {
      this.$confirm('', {
        title: 'Spustit synchronizaci?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.data.loading = true
          this.startDataSync(['TZB_ELECTRICITY_PRODUCT', 'TZB_GAS_PRODUCT']).finally(() => {
            this.data.loading = false
            this.loadDataSyncInfo()
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
.sync-content {
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 12px;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 12px;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
    background-color: transparent !important;
  }
}
</style>
